import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { ChartPeriod } from "../types";
import { setGraphPeriodH } from "../tickerDataSlice";

export const useGraphPeriodH = (graphId: string) => {
	const dispatch = useDispatch();
	const period = useSelector<StoreType, ChartPeriod>(s => s.data.trading.ticker.graphPeriodH[graphId || ""]);

	console.log(period)
	
	const dispatchSetPeriod = React.useCallback(
		(newPeriod: ChartPeriod) => {
			if (graphId) {
				dispatch(
					setGraphPeriodH({
						graphId,
						data: newPeriod,
					})
				);
			}
		},
		[dispatch, graphId]
	);

	return [period || ChartPeriod.Month, dispatchSetPeriod] as [typeof period, typeof dispatchSetPeriod];
};
